import type { GroupByOption } from '../list-controls';

export type WorkItemsTab = 'board' | 'table' | 'timeline';

export type GroupBy = 'none' | 'epic' | 'status' | 'assignee' | 'priority';

/**
 * Indexed by `string` so this shape is also assignable to the generic
 * `FilterDict` consumed by `<FilterPopover>` / `<ActiveFilterChips>` /
 * `<ListControlBar>`. Named fields remain authoritative for the page-local
 * `applyFilters()` logic.
 */
export interface WorkItemFilters extends Record<string, string[]> {
  type: string[];
  status: string[];
  assignee: string[];
  epic: string[];
  priority: string[];
  sprint: string[];
}

export const EMPTY_FILTERS: WorkItemFilters = {
  type: [],
  status: [],
  assignee: [],
  epic: [],
  priority: [],
  sprint: []
};

export type FacetKey = keyof WorkItemFilters;

export const GROUP_BY_OPTIONS: ReadonlyArray<GroupByOption & { key: GroupBy }> = [
  { key: 'none', label: 'None' },
  { key: 'epic', label: 'Epic' },
  { key: 'status', label: 'Status' },
  { key: 'assignee', label: 'Assignee' },
  { key: 'priority', label: 'Priority' }
];

export function parseGroupBy(raw: string | null): GroupBy {
  switch (raw) {
    case 'epic':
    case 'status':
    case 'assignee':
    case 'priority':
      return raw;
    default:
      return 'none';
  }
}
